<template>
  <div class="panel">
    <div class="panel-heading">{{heading}}</div>
    <div class="panel-body">
    <canvas ref="chart" :style="{height: '150px', width:'800px'}"></canvas>
    </div>
    <div class="control-row">
      <div class="duration">
        <v-select class="duration"
                  :items="durationSelectItems"
                  item-text="label"
                  item-value="duration"
                  label="Bond Duration"
                  dense
                  solo
                  @change="onDurationChange"></v-select>
      </div>
      <v-btn v-if="!animationRunning" depressed color="primary" @click="onAnimationToggle">
        Start Animation
      </v-btn>
      <v-btn v-else depressed color="error" @click="onAnimationToggle">
        Stop Animation
      </v-btn>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js';
  import * as data from '../../../client/src/data.js';
  import CrosshairPlugin from '../plugins/plugin.crosshair';
  import About from './About';

  export default {
    props:{
      yieldsForDuration: Array
    },
    data () {
      return {
        chart: null,
        durationSelectItems: data.LONG_DURATION_LABELS.map(label => ({label: label[1], duration: label[0]})),
        duration: 120,
        animationRunning: false,
        enableCallback: true,
        animationTimer: null,
        currentAnimationFrame: 0,
        showAbout: false,
        options: {
          animation: false,
          maintainAspectRatio: false,
          hover: {
            intersect: false,
            mode: 'index'
          },
          tooltips: {
            enabled: false
          },
          legend: {
            display: false
          },
          elements: {
            point: {
              radius: 0,
              hoverRadius: 0
            }
          },
          scales: {
            xAxes: [{
              type: 'time',
              ticks: {
                autoSkip: true,
                maxTicksLimit: 20
              },
              time: {
                unit: 'year'
              }
            }],
            yAxes: [{
              ticks: {
                callback: value => value.toFixed(1) + '%'
              }
            }]
          }
        }
      };
    },
    computed: {
      heading() {
        return data.getDurationLabel(this.duration) + " treasury bond yield history";
      }
    },
    watch: {
      yieldsForDuration(yields) {
        if(yields) {
          this.chart = new Chart(this.$refs.chart, {
            plugins: [new CrosshairPlugin(this.handleMouseOver.bind(this))],
            type: 'line',
            data: {
              datasets: [{
                data: this.yieldsForDuration,
                borderColor: '#4A87D0',
                borderWidth: '2',
                backgroundOpacity: '.3',
                backgroundColor: 'rgba(74,135,208, .5)'
              }]
            },
            options: this.options});
        }
      },
    },
    methods: {
      onDurationChange(value) {
        this.duration = value;
        this.$emit('onDurationChange', value);
      },
      handleMouseOver(date, index) {
        if (this.enableCallback) {
          this.$emit('onDateChange', date);
          this.currentAnimationFrame = index;
        }
        this.enableCallback = true;
      },
      onAnimationToggle() {
        if(!this.animationRunning) {
          this.animateYieldCurve();
        } else {
          clearTimeout(this.animationTimer);
        }
        this.animationRunning = !this.animationRunning;

      },
      animateYieldCurve() {
        const yieldSpreadData = data.getYieldsForDuration(this.duration);
        const numFrames = yieldSpreadData.length;
        this.drawCrosshairAtIndex(this.currentAnimationFrame);

        this.currentAnimationFrame = this.currentAnimationFrame + 1;
        if (this.currentAnimationFrame >= numFrames) {
          this.currentAnimationFrame = 0;
        }
        this.$emit('onDateChange', new Date(yieldSpreadData[this.currentAnimationFrame].t));

        this.animationTimer = setTimeout(this.animateYieldCurve.bind(this), 5);
      },
      drawCrosshairAtIndex(index) {
        this.enableCallback = false;
        this.chart.update(0);

        const points = this.chart.getDatasetMeta(0).data;
        const canvasRect = this.chart.canvas.getBoundingClientRect();
        const xCoord = canvasRect.left + points[index]._model.x;
        const yCoord = canvasRect.top + points[index]._model.y;

        const event = new MouseEvent('mousemove', {
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: xCoord,
          clientY: yCoord
        });
        this.chart.canvas.dispatchEvent(event);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .control-row {
    display: flex;
    margin-top: 10px;

    .duration {
      width: 150px;
      margin-right: 20px;
    }

  }
</style>

